var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 54,
    viewBox: "0 0 65 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.179 0.333252C17.9139 0.333252 16.1514 2.09567 16.1514 4.36085V5.13635H45.7706C49.7342 5.13635 52.9752 8.37731 52.9752 12.341V37.9575C52.9752 38.9404 52.76 39.8785 52.3998 40.7343C52.3969 40.7407 52.4028 40.7513 52.3998 40.7593L56.0272 44.3617H56.1773H57.7783V32.3539H60.1548C62.42 32.3539 64.1824 30.5915 64.1824 28.3263V4.36085C64.1824 2.09568 62.42 0.333252 60.1548 0.333252H20.179ZM4.1437 8.33842C1.89857 8.33842 0.141113 10.0959 0.141113 12.341V37.9575C0.141113 40.2027 1.89857 41.9601 4.1437 41.9601H6.54525V53.9679H8.14628H8.29638L19.8288 42.4354C20.1265 42.1344 20.5312 41.9635 20.9545 41.9601H45.7706C48.0157 41.9601 49.7731 40.2027 49.7731 37.9575V12.341C49.7731 10.0959 48.0157 8.33842 45.7706 8.33842H4.1437ZM24.9571 15.5431C28.0519 15.5431 30.5607 18.0519 30.5607 21.1467C30.5607 22.563 30.0264 23.8375 29.1598 24.8241C32.6006 26.5732 35.3638 30.3491 35.3638 34.7555H14.5504C14.5504 30.3491 17.3136 26.5732 20.7544 24.8241C19.8878 23.8375 19.3535 22.563 19.3535 21.1467C19.3535 18.0519 21.8623 15.5431 24.9571 15.5431Z",
    fill: "#A9A6AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.f88c77b43555a471e597df975baf461b.svg";
export { ForwardRef as ReactComponent };